import React from 'react';
import { Handle, Position } from 'react-flow-renderer';
import { MessageCircle, Webhook, Clock } from 'lucide-react';

const iconMap = {
  whatsapp: MessageCircle,
  webhook: Webhook,
  schedule: Clock
};

const TriggerNode = ({ data, selected }) => {
  const Icon = iconMap[data.subtype] || MessageCircle;

  return (
    <div
      style={{
        padding: '16px',
        borderRadius: '12px',
        border: `2px solid ${selected ? '#047857' : '#10aa62'}`,
        background: 'rgba(16, 170, 98, 0.1)',
        minWidth: '200px',
        boxShadow: selected ? '0 0 20px rgba(16, 170, 98, 0.4)' : '0 4px 6px rgba(0, 0, 0, 0.1)',
        transition: 'all 0.2s'
      }}
    >
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
        <Icon size={20} color="#10aa62" />
        <div>
          <div style={{ fontWeight: 600, fontSize: 14, color: '#1f2937' }}>
            {data.label || 'Trigger'}
          </div>
          <div style={{ fontSize: 11, color: '#6b7280', marginTop: 2 }}>
            {data.subtype || 'trigger'}
          </div>
        </div>
      </div>

      <Handle
        type="source"
        position={Position.Right}
        style={{
          background: '#10aa62',
          width: 12,
          height: 12,
          border: '2px solid white'
        }}
      />
    </div>
  );
};

export default TriggerNode;
